import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Radio, Checkbox } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

const ActiveDaysSelector =
({
    activeDays,
    setActiveDays
})=>{
    const { t } = useTranslation();
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

    const daySelector = (day) => {
        return(
            <Grid.Column key={day}>
                <Checkbox
                    label={t("days." + day.toLowerCase())}
                    disabled={!activeDays.Enabled}
                    checked={activeDays[day]}
                    onClick={
                        (e, data) => activeDays.Enabled && setActiveDays(prev => ({ ...prev, [day]: data.checked }))
                    }
                />
            </Grid.Column>
        )
    }

    return (
        <>
        <Grid.Row columns={2}>
            <Grid.Column textAlign="left" width={3}>
            <label >{t("account.adminConsole.activeDays")}</label>
            </Grid.Column>
            <Grid.Column textAlign="left">
            <Radio
                toggle
                checked={activeDays.Enabled}
                onChange={() => {
                    setActiveDays(prev => ({ ...prev, Enabled: !prev.Enabled }));
                }}
            />
            </Grid.Column>
        </Grid.Row>
        <Grid.Column mobile={8} widescreen={11} tablet={11} textAlign="left">
            <Grid columns={7} stackable>
                <Grid.Row>
                    {days.map(day => daySelector(day))}
                </Grid.Row>
            </Grid>
        </Grid.Column>
        </>
    )
}

ActiveDaysSelector.propTypes = {
    activeDays: PropTypes.object.isRequired,
    setActiveDays: PropTypes.func.isRequired
}

export default ActiveDaysSelector